import { SourceOfIncome } from "Infrastructure/Api/Api";
import type { CodeListItem } from "Models/ICodeListDto";
import { Resources, useResource } from "Translations/Resources";
import { useMemo } from "react";

type ListItem = CodeListItem<SourceOfIncome>;
type Result = ListItem[];

const LEGACY_VALUES: Array<SourceOfIncome> = [
  SourceOfIncome.Employment,
  SourceOfIncome.SelfEmployment,
  SourceOfIncome.Other,
];

export const useSourceOfIncomeList = () => {
  const { t } = useResource();

  return useMemo<Result>(
    () =>
      Object.entries(SourceOfIncome)
        .filter(([key]) => !LEGACY_VALUES.includes(key as SourceOfIncome))
        .map<ListItem>(([key]) => ({
          code: key as SourceOfIncome,
          name: t(Resources.Form.SourceOfIncome[key as SourceOfIncome]),
        })),
    [t],
  );
};
